export type StorePageType = string

type Store = {
  pageType: StorePageType
  pageTypeId: string
  pageHeight: number
}

export default () =>
  useState<Store>('store', () => ({
    pageType: '',
    pageTypeId: '',
    pageHeight: 0,
  }))
